<div class="container">
  @switch (BANNER_TYPE[bannerType].type) {
    <!-- SUCCESS BANNER-->
    @case (BANNER_MESSAGE_TYPE.SUCCESS) {
      <div class="background-success" [ngClass]="{ 'nav-open': drawerOpen }">
        <ion-icon class="icon" [src]="IMAGES.BANNER_SUCCESS"></ion-icon>
        <div class="text">{{ BANNER_TYPE[bannerType].text }}</div>
        <ion-icon
          class="icon"
          [src]="IMAGES.CLOSE_BLACK"
          alt="close"
          (click)="clickExit()"
          onkeypress="clickExit()"
        ></ion-icon>
      </div>
    }
    <!-- CAUTION BANNER-->
    @case (BANNER_MESSAGE_TYPE.CAUTION) {
      <div class="caution-container">
        <div class="background-caution" [ngClass]="{ 'nav-open': drawerOpen }">
          <ion-icon class="icon" [src]="IMAGES.CAUTION"></ion-icon>
          <div class="text">{{ BANNER_TYPE[bannerType].text }}</div>
          <ion-icon
            class="icon"
            [src]="IMAGES.CLOSE_BLACK"
            alt="close"
            (click)="clickExit()"
            onkeypress="clickExit()"
          ></ion-icon>
        </div>

        @if (commonUtils.fileUploadResponse) {
          <div class="file-upload-response-container">
            <div class="results-from-upload">
              <div class="device-name">
                <span class="sub-headers-file-upload"
                  >{{ FILE_UPLOAD_RESPONSE.DEVICE_NAME }} :</span
                >
                {{ deviceNameFromMessage }}
              </div>
              <div class="total-items-response">
                <span class="sub-headers-file-upload"
                  >{{ FILE_UPLOAD_RESPONSE.NUMBER_OF_ROWS }} :</span
                >
                {{ commonUtils.fileUploadResponse.totalNumberOfItems }}
              </div>

              <div class="building-scan-response">
                <span class="sub-headers-file-upload"
                  >{{ FILE_UPLOAD_RESPONSE.BUILDING_SCANS }} :</span
                >
                {{ FILE_UPLOAD_RESPONSE.ACCEPTED }} :
                {{ commonUtils.fileUploadResponse.acceptedBuildingScans }}
                {{ FILE_UPLOAD_RESPONSE.REJECTED }} :
                {{ commonUtils.fileUploadResponse.rejectedBuildingScans }}
              </div>

              <div class="packages-response">
                <span class="sub-headers-file-upload">
                  {{ FILE_UPLOAD_RESPONSE.PACKAGES }} :</span
                >
                {{ FILE_UPLOAD_RESPONSE.ACCEPTED }} :
                {{ commonUtils.fileUploadResponse.acceptedPackages }}
                {{ FILE_UPLOAD_RESPONSE.REJECTED }} :
                {{ commonUtils.fileUploadResponse.rejectedPackages }}
              </div>

              <div class="stops-response">
                <span class="sub-headers-file-upload">
                  {{ FILE_UPLOAD_RESPONSE.STOPS }} :</span
                >
                {{ FILE_UPLOAD_RESPONSE.ACCEPTED }} :
                {{ commonUtils.fileUploadResponse.acceptedStops }}
                {{ FILE_UPLOAD_RESPONSE.REJECTED }} :
                {{ commonUtils.fileUploadResponse.rejectedStops }}
              </div>

              <div class="invalid-response">
                <span class="sub-headers-file-upload">
                  {{ FILE_UPLOAD_RESPONSE.INVALID }} :</span
                >
                {{ commonUtils.fileUploadResponse.invalidLines }}
              </div>

              @if (commonUtils.errorMessage) {
                <div class="error-message">
                  @for (line of commonUtils.errorMessage; track line) {
                    <p>{{ line }}</p>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- FAIL BANNER-->
    @case (BANNER_MESSAGE_TYPE.FAIL) {
      <div class="fail-container" [ngClass]="{ 'nav-open': drawerOpen }">
        <div class="background-fail">
          <ion-icon class="icon-fail" [src]="IMAGES.BANNER_FAIL"></ion-icon>
          <div class="text">{{ BANNER_TYPE[bannerType].text }}</div>
          <ion-icon
            class="icon"
            [src]="IMAGES.CLOSE_BLACK"
            alt="close"
            (click)="clickExit()"
            onkeypress="clickExit()"
          ></ion-icon>
        </div>
        @if (commonUtils.errorMessage) {
          <div class="error-message">
            <p>
              {{ commonUtils.errorMessage[0] }}
              <a [href]="commonUtils.errorHref">
                {{ commonUtils.errorMessage[1] }}
              </a>
              {{ commonUtils.errorMessage[2] }}
            </p>
          </div>
        }
      </div>
    }
    <!-- GENERIC 400 BANNER-->
    @case (BANNER_MESSAGE_TYPE.FAIL_400) {
      <div class="fail-container" [ngClass]="{ 'nav-open': drawerOpen }">
        <div class="background-fail">
          <ion-icon class="icon-fail" [src]="IMAGES.BANNER_FAIL"></ion-icon>
          <div class="text">
            {{ BANNER_TYPE[bannerType].text.replace("%s", BANNER_400_MESSAGE) }}
          </div>
          <ion-icon
            class="icon"
            [src]="IMAGES.CLOSE_BLACK"
            alt="close"
            (click)="clickExit()"
            onkeypress="clickExit()"
          ></ion-icon>
        </div>
      </div>
    }
  }
</div>
